import React from 'react';
import { withBaseIcon } from 'react-icons-kit';
import { ic_delete } from 'react-icons-kit/md/ic_delete';
import { arrows_slim_left } from 'react-icons-kit/linea/arrows_slim_left';
import { ic_filter_list } from 'react-icons-kit/md/ic_filter_list';
import { ic_clear } from 'react-icons-kit/md/ic_clear';
import { arrowUnsorted } from 'react-icons-kit/typicons/arrowUnsorted';
import { arrowSortedUp } from 'react-icons-kit/typicons/arrowSortedUp';
import { arrowSortedDown } from 'react-icons-kit/typicons/arrowSortedDown';
import { ic_error } from 'react-icons-kit/md/ic_error';
import { ic_fiber_manual_record } from 'react-icons-kit/md/ic_fiber_manual_record';
import { ic_search } from 'react-icons-kit/md/ic_search';
import { ic_arrow_forward } from 'react-icons-kit/md/ic_arrow_forward';
import { ic_keyboard_arrow_down } from 'react-icons-kit/md/ic_keyboard_arrow_down';
import { ic_keyboard_arrow_right } from 'react-icons-kit/md/ic_keyboard_arrow_right'
import { ic_keyboard_arrow_up } from 'react-icons-kit/md/ic_keyboard_arrow_up';
import { lineArrowLeft } from 'react-icons-kit/oct/lineArrowLeft';
import { lineArrowRight } from 'react-icons-kit/oct/lineArrowRight';
import { eye } from 'react-icons-kit/entypo/eye';
import { withLine } from 'react-icons-kit/entypo/withLine';
import { ic_info_outline } from 'react-icons-kit/md/ic_info_outline'
import { ic_done } from 'react-icons-kit/md/ic_done';
import { ic_help_outline } from 'react-icons-kit/md/ic_help_outline';
import { ic_translate } from 'react-icons-kit/md/ic_translate';
import { ic_cached } from 'react-icons-kit/md/ic_cached';
import { checkmarkCircled } from 'react-icons-kit/ionicons/checkmarkCircled';
import { androidRadioButtonOff } from 'react-icons-kit/ionicons/androidRadioButtonOff';
import { androidAlert } from 'react-icons-kit/ionicons/androidAlert';
import { ban } from 'react-icons-kit/iconic/ban';
import { androidWarning } from 'react-icons-kit/ionicons/androidWarning';
import { lifebuoy } from 'react-icons-kit/icomoon/lifebuoy';
import { ic_content_copy_outline } from 'react-icons-kit/md/ic_content_copy_outline';
import { ic_menu } from 'react-icons-kit/md/ic_menu';
import { ic_playlist_add } from 'react-icons-kit/md/ic_playlist_add';
import { ic_add_circle_outline } from 'react-icons-kit/md/ic_add_circle_outline';
import { ic_rule_outline } from 'react-icons-kit/md/ic_rule_outline'

const IconContainer = withBaseIcon({ size: 30 });
interface ArrowProps {
    onClick?: Function;
}

export const Delete = () => <IconContainer icon={ic_delete} className="text-orange" />;
export const BackArrow = () => <IconContainer icon={arrows_slim_left} size={18} />;
export const NextArrow: React.FC<ArrowProps> = ({ onClick }) => (
    <IconContainer icon={lineArrowRight} size={18} onClick={onClick} />
);
export const PrevArrow: React.FC<ArrowProps> = ({ onClick }) => (
    <IconContainer icon={lineArrowLeft} size={18} onClick={onClick} />
);
export const FilterIcon = () => <IconContainer icon={ic_filter_list} size={20} />
export const Clear = () => <IconContainer icon={ic_clear} size={18} />
export const Clear_Large = () => <IconContainer icon={ic_clear} size={24} />
export const SortingArrows = () => <IconContainer icon={arrowUnsorted} size={18} className="text-dark-green" />
export const SortedUp = () => <IconContainer icon={arrowSortedUp} size={18} className="text-dark-green" />
export const SortedDown = () => <IconContainer icon={arrowSortedDown} size={18} className="text-dark-green" />
export const NavBarSortedUp = () => <IconContainer icon={arrowSortedUp} size={18} className="text-black" />
export const NavBarSortedDown = () => <IconContainer icon={arrowSortedDown} size={18} className="text-black" />
export const LogsFilterSortedUp = () => <IconContainer icon={arrowSortedUp} size={18} className="text-medium-gray hover:text-status-green" />
export const LogsFilterSortedDown = () => <IconContainer icon={arrowSortedDown} size={18} className="text-medium-gray hover:text-status-green" />
export const ProfileDropdown = () => <IconContainer icon={arrowSortedDown} size={18} className="text-white" />
export const AttentionIcon = () => <IconContainer icon={ic_error} size={18} className="text-orange" />
export const HealthyIcon = () => <IconContainer icon={ic_fiber_manual_record} size={22} className="text-status-green" />
export const SearchIcon = () => <IconContainer icon={ic_search} size={20} />;
export const ArrowUp = () => <IconContainer icon={ic_keyboard_arrow_up} size={24} className="text-dark-green" />
export const ArrowDown = () => <IconContainer icon={ic_keyboard_arrow_down} size={24} className="text-dark-green" />
export const ArrowRight = () => <IconContainer icon={ic_keyboard_arrow_right} size={24} className="text-dark-green" />
export const ArrowForward = ({ size = 24, className }: { size?: number, className?: string }) => <IconContainer icon={ic_arrow_forward} size={size} className={className} />
export const ArrowRightGray = () => <IconContainer icon={ic_keyboard_arrow_right} size={24} className="text-medium-gray" />
export const ShowString = () => <IconContainer icon={eye} size={18} className="text-off-black" />
export const HideString = () => <IconContainer icon={withLine} size={18} className="text-off-black" />
export const ToolTipIcon = () => <IconContainer icon={ic_info_outline} size={18} className={"text-medium-gray hover:text-status-green"} />
export const Checkmark = () => <IconContainer icon={ic_done} size={18} className="text-status-green" />
export const TranslateIcon = () => <IconContainer icon={ic_translate} size={18} />
export const RefreshSpinner = () =>
    <IconContainer
        icon={ic_cached}
        size={18}
        className="text-medium-gray hover:text-dark-green cursor-pointer m-auto pb-1" // Add m-auto to center the icon
        style={{ display: 'block' }} // Ensure it's a block element
    />
export const CurrentStep = () => <IconContainer icon={androidRadioButtonOff} size={18} className="text-status-green" />
export const UnselectedStep = () => <IconContainer icon={androidRadioButtonOff} size={18} className="text-medium-gray" />
export const CompletedStep = () => <IconContainer icon={checkmarkCircled} size={18} className="text-status-green" />
export const HelpCenterIcon = () => <IconContainer icon={lifebuoy} size={18} className="text-dark-green mx-1 transition-colors duration-300" />
export const CopyToClipboard = () => <IconContainer icon={ic_content_copy_outline} size={18} className="cursor-pointer text-off-black" />

export const HealthyStatusIcon = () => <IconContainer icon={checkmarkCircled} size={20} className="text-status-green" />;
export const UnhealthyStatusIcon = () => <IconContainer icon={androidAlert} size={20} className="text-orange" />;
export const DisabledStatusIcon = () => <IconContainer icon={ban} size={20} className="text-medium-gray" />;
export const NeedsReviewStatusIcon = () => <IconContainer icon={androidWarning} size={20} className="text-warning-dark-yellow" />;
export const AddExistingDestinationIcon = () => <IconContainer icon={ic_playlist_add} size={40} className="text-dark-green" />;
export const CreateNewDestinationIcon = () => <IconContainer icon={ic_add_circle_outline} size={40} className="text-dark-green" />;
export const RuleConfiguredIcon = () => <IconContainer icon={ic_rule_outline} size={18} className="text-dark-green" />;
export const OneDirectionIcon = ({ size = 36, className }: { size?: number | string, className?: string }) => (
    <svg width={size} height={size} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <circle cx="18" cy="18" r="17.5" stroke="currentColor" />
        <path d="M18 10L16.59 11.41L22.17 17H10V19H22.17L16.59 24.59L18 26L26 18L18 10Z" fill="currentColor" />
    </svg>
);
